import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { GetEmployeeName } from "../../services/authService";

const ReportIssues = () => {
  const [iframeUrl, setIframeUrl] = useState("");
  const [loading, setLoading] = useState(true);

  const projectUID = "9B6383C9-8BB3-4BAA-BA4B-77750A61B681";

  useEffect(() => {
    const loadIframeUrl = async () => {
      try {
        const token = Cookies.get("employeeToken");
        if (!token) {
          setLoading(false);
          return;
        }

        const res = await GetEmployeeName(token);
        if (res?.data?.status === "Success") {
          const email = res.data.email;

          const url = `https://orbit.vrsamadhantech.com/Report-Issue/${projectUID}?email=${encodeURIComponent(
            email
          )}`;

          setIframeUrl(url);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadIframeUrl();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center w-100 h-100">
        Loading Report Issue...
      </div>
    );
  }

  return (
    <div className="w-100 h-100" style={{ paddingTop: "80px" }}>
      <iframe
        src={iframeUrl}
        title="Report Issue"
        className="w-100 border-0"
        style={{
          height: "calc(100vh - 140px)",
        }}
        allow="camera; microphone; clipboard-write"
      />
    </div>
  );
};

export default ReportIssues;
